import { Container } from 'inversify';
import { initDiContainer as initDiContainerDefault } from '@edikk-edikk/country-frontend';
import { initApi } from '#srcJs/di-container/init/init-api';

const initDiContainer = (): Container => initDiContainerDefault((diContainer: Container) => {
  initApi(diContainer);
});

export { initDiContainer };
